import { cn } from '@/shared/lib/cn';
import React from 'react';

interface TimelineProps {
  children: React.ReactNode;
  className?: string;
  dotClassName?: string;
  showLine?: boolean;
}

/**
 * Monochrome timeline: a hairline rail with small ring nodes. The rail sits
 * at 34.5px from the container edge; content is indented by ml-16 (64px), so
 * node offsets are expressed relative to the content column.
 */
export const Timeline: React.FC<TimelineProps> = ({
  children,
  className = '',
  dotClassName = '',
  showLine = true,
}) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <div className={`relative ${className}`}>
      {/* Timeline rail */}
      {showLine && (
        <div className="absolute top-0.5 bottom-0.5 left-8.5 z-0 hidden w-px bg-border lg:block"></div>
      )}
      <div className="relative z-10 space-y-8 lg:ml-16">
        {childrenArray.map((child, index) => (
          <div
            key={React.isValidElement(child) ? (child.key ?? index) : index}
            className="relative"
          >
            {/* Timeline node: small ring on the rail */}
            {showLine && (
              <div
                className={cn(
                  'absolute top-7.5 left-[-34.5px] z-20 hidden size-2.5 rounded-full border-2 border-foreground bg-background lg:block',
                  dotClassName,
                )}
              ></div>
            )}
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};
